import { Typography } from 'components/DesignSystemV2/Typography';
import { LazyImage } from 'components/LazyImage';
import React from 'react';
import { colorsV2 } from 'style/colors-v2';
import styled from 'styled-components';

const Container = styled.div`
  padding: 32px 40px;
  border-radius: 8px;
  border: 1px solid ${colorsV2.neutral20};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyJuniorSchedule = () => {
  return (
    <Container>
      <LazyImage handle="cm92j9nks8tbe070zloylhero" />
      <div>
        <Typography variant="medium/16-24" color={colorsV2.neutral180}>
          Sắp ra mắt...
        </Typography>
        <Typography variant="regular/16-24" color={colorsV2.neutral140}>
          Bạn quay lại sau nhé!
        </Typography>
      </div>
    </Container>
  );
};
